export const mapKeys = {
  TAX_CODE: 'taxCode',
  COMPANY_NAME: 'companyName',
  LAST_PURCHASE_DATE: 'lastPurchaseDate',
  LANGUAGE: 'languageCode',
  CURRENCY: 'currencyCode',
  UNIT: 'currencyUnit',
  ADDITIONAL_CURRENCY: 'additionalCurrencyCode',
  ADDITIONAL_UNIT: 'additionalCurrencyUnit',
}

export const mapCurrency = {
  VND: {
    label: 'VND',
    value: 'VND',
    isI18n: false,
  },
  USD: {
    label: 'USD',
    value: 'USD',
    isI18n: false,
  },
  EUR: {
    label: 'EUR',
    value: 'EUR',
    isI18n: false,
  },
}

export const BLANK_OPTION = {
  label: 'common.BLANK',
  value: 'BLANK',
  isI18n: true,
}
